module.exports = __webpack_public_path__ + "img/PLCConfig.f61174b9.png";